
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search-common",
      function () {
        return require("private-next-pages/search-common/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search-common"])
      });
    }
  